import React, { useState, useEffect } from "react"
import _isEmpty from "lodash/isEmpty"
import _startCase from "lodash/startCase"
import { useSelector, useDispatch } from "react-redux"

import emailIcon from "@/public/icons/email.svg"
import phoneIcon from "@/public/icons/phone-icon.svg"

import { validateField, mapStateToCountryHandler } from "@/utils/helper"
import CONSTANTS from "@/constants"

import {
  getCountryList,
  getstateList,
  selectGenericState,
} from "@/store/features/genericSlice"

import Input from "@/components/core/Input/Input"
import Dropdown from "@/components/core/SelectDropdown/SelectDropdown"
import RadioButton from "@/components/core/RadioButton/RadioButton"
import { convertToPhoneNumber } from "@/components/RegisterOnlineProduct/v1/RegisterOnlineHelper"
import { getConfig } from "@/constants/config"

const ContactInfo = props => {
  const [countries, setCountries] = useState([])
  const {
    activeTab = "",
    data = {},
    labels = {},
    setData = () => {},
    error = {},
    i18n = {},
    setError = () => {},
    onBlur = () => {},
  } = props

  const {
    CREATE_ACCOUNT_TYPE: { HOME_OWNER = "", TRADE_ACCOUNT = "" },
  } = CONSTANTS
  const HOME_OWNER_TAB = _startCase(HOME_OWNER)
  const TRADE_TAB = _startCase(TRADE_ACCOUNT)
  const isMobile = window.innerWidth <= 480
  const {
    countryListPath,

    stateListPath,
  } = useSelector(selectGenericState)
  const marketList = ["Residential", "Commercial"]
  const dispatch = useDispatch()
  useEffect(() => {
    setData({ ...data, state: {} })
  }, [data?.country])

  useEffect(() => {
    try {
      if (!_isEmpty(countryListPath) && !_isEmpty(stateListPath)) getLocations()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
    }
  }, [countryListPath, stateListPath])

  const getLocations = async () => {
    if (countryListPath && stateListPath) {
      const countryData = await dispatch(getCountryList())
      const stateData = await dispatch(getstateList())

      const mapList =
        (!_isEmpty(countryData?.payload) &&
          !_isEmpty(stateData?.payload) &&
          mapStateToCountryHandler(countryData?.payload, stateData?.payload)) ||
        []
      setCountries(mapList)
      const config = await getConfig()
      const countryCode = config?.internationalization?.country ?? "US"
      setData({
        ...data,
        country: mapList.find(country => country?.code === countryCode) ?? {},
      })
    }
  }

  const onInputChange = e => {
    const { target: { value = "", id = "" } = {} } = e
    const field = id?.split("-")
    setData({
      ...data,
      [field[2]]: value,
    })
    setError(prevError => ({
      ...prevError,
      [field[2]]: null,
    }))
  }

  const onNameChange = async e => {
    const { target: { value = "", id = "" } = {} } = e
    const field = id?.split("-")
    if (value === "" || (await validateField("name", value))) {
      setData({
        ...data,
        [field[2]]: value,
      })
      setError(prevError => ({
        ...prevError,
        [field[2]]: null,
      }))
    }
  }

  const changeCountry = country => {
    setData({
      ...data,
      country: countries?.find(c => c?.name === country),
    })
  }

  const radioKeyDown = e => {
    const nextRadio = e.target.nextSibling
    const previousRadio = e.target.previousSibling
    if (e.key === "ArrowLeft" && previousRadio) {
      previousRadio.focus()
    } else if (e.key === "ArrowRight" && nextRadio) {
      nextRadio.focus()
    } else if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      e.target.click()
    }
  }

  return (
    <div className="container mb-40">
      {activeTab === TRADE_TAB && (
        <div className="row mx-0">
          <div className="col-6 py-4">
            <RadioButton
              id="contact-user-market-residential"
              name="contact-user-market"
              value={marketList[0]}
              checked={data.market === marketList[0] || data.market === ""}
              onClick={() => setData({ ...data, market: marketList[0] })}
              onKeydown={radioKeyDown}
            />
          </div>
          <div className="col-6 py-4">
            <RadioButton
              id="contact-user-market-commercial"
              name="contact-user-market"
              value={marketList[1]}
              checked={data.market === marketList[1]}
              onClick={() => setData({ ...data, market: marketList[1] })}
              onKeydown={radioKeyDown}
            />
          </div>
          <div className="col-12 px-0">
            <Input
              id="contact-user-business"
              type="text"
              value={data.company}
              maxLength={50}
              placeholder={`${i18n.businessName}*`}
              label={`${i18n.businessName}*`}
              onChange={e => {
                const { value } = e.target
                if (validateField("businessName", value) || value === "") {
                  setData({
                    ...data,
                    ["company"]: value,
                  })
                }
              }}
              showError={error.business}
              errorMessage={error.business}
              onBlur={() => props.onBlur("business")}
            />
          </div>
        </div>
      )}
      <div className="row mx-0">
        <div
          className={`col-12 col-sm-6 col-md-6 pl-0 ${
            isMobile ? "pr-0" : "pr-10"
          }`}
        >
          <Input
            id="contact-user-fname"
            type="text"
            value={data?.fname}
            maxLength={40}
            placeholder={`${i18n?.fname}*`}
            label={`${i18n?.fname}*`}
            onChange={onNameChange}
            showError={error?.fname}
            errorMessage={error?.fname}
            onBlur={() => onBlur("fname")}
          />
        </div>
        <div
          className={`col-12 col-sm-6 col-md-6 pr-0 ${
            isMobile ? "pl-0" : "pl-10"
          }`}
        >
          <Input
            id="contact-user-lname"
            type="text"
            value={data?.lname}
            maxLength={40}
            placeholder={`${i18n?.lname}*`}
            label={`${i18n?.lname}*`}
            onChange={onNameChange}
            showError={error?.lname}
            errorMessage={error?.lname}
            onBlur={() => onBlur("lname")}
          />
        </div>
      </div>
      <div className="row mx-0">
        <div className="col-12 px-0">
          <Input
            id="contact-user-email"
            type="text"
            value={data?.email}
            maxLength={60}
            prefix={<img src={emailIcon?.src} alt="" aria-hidden="true" />}
            placeholder={`${i18n?.email}*`}
            label={`${i18n?.email}*`}
            onChange={onInputChange}
            showError={error?.email}
            errorMessage={error?.email}
            onBlur={() => onBlur("email")}
          />
        </div>
        <div className="col-12 px-0">
          <Input
            id="contact-user-cemail"
            type="text"
            prefix={<img src={emailIcon?.src} alt="" aria-hidden="true" />}
            value={data?.cemail}
            maxLength={60}
            placeholder={`${i18n?.cemail}*`}
            label={`${i18n?.cemail}*`}
            onChange={onInputChange}
            showError={error?.cemail}
            errorMessage={error?.cemail}
            onBlur={() => onBlur("cemail")}
          />
        </div>
      </div>
      <div className="row mx-0">
        <div
          className={`col-12 col-sm-6 col-md-6 pl-0 ${
            isMobile ? "pr-0" : "pr-10"
          }`}
        >
          <Input
            id="contact-user-phone"
            type="text"
            maxLength={60}
            placeholder={`${
              activeTab === HOME_OWNER_TAB
                ? i18n?.phoneNumber
                : i18n?.businessPhone
            }*`}
            label={`${
              activeTab === HOME_OWNER_TAB
                ? i18n?.phoneNumber
                : i18n?.businessPhone
            }*`}
            prefix={<img src={phoneIcon?.src} alt="" aria-hidden="true" />}
            value={data?.phone}
            onChange={e =>
              setData({ ...data, phone: convertToPhoneNumber(e.target.value) })
            }
            showError={error?.phone}
            errorMessage={error?.phone}
            onBlur={() => onBlur("phone")}
          />
        </div>
        <div
          className={`col-12 col-sm-6 col-md-6 pr-0 ${
            isMobile ? "pl-0" : "pl-10"
          }`}
        >
          <Input
            id="contact-user-zipcode"
            type="text"
            value={data?.zipcode}
            maxLength={7}
            autoComplete={true}
            placeholder={`${i18n?.zipcode}*`}
            label={`${
              labels && labels.zipCodeLabel
                ? labels.zipCodeLabel
                : i18n?.zipcode
            }*`}
            onChange={onInputChange}
            showError={error?.zipcode}
            errorMessage={error?.zipcode}
            onBlur={() => onBlur("zipcode")}
          />
        </div>
      </div>
      <div className="row mx-0">
        <div
          className={`col-12 col-sm-6 col-md-6 pl-0 ${
            isMobile ? "pr-0" : "pr-10"
          }`}
        >
          <Dropdown
            id="contact-user-country"
            data={countries.map(country => country?.name)}
            name="country"
            value={data?.country?.name ?? ""}
            label={`${i18n?.country}`}
            onChange={changeCountry}
            showError={error?.country}
            errorMessage={error?.country}
          />
        </div>
      </div>
    </div>
  )
}

export default ContactInfo
